export default "__VITE_ASSET__ClbR0DNr__"